



























import Vue from 'vue';
import { Toast } from '@/components/ds';
import BottomButton from '@/components/BottomButton.vue';
import LoadingPage from '@/components/LoadingPage.vue';
import ProuniPipelineMenu from '@/components/prouni/ProuniPipelineMenu.vue';

export default Vue.extend({
  name: 'ProuniStepLayout',
  components: { BottomButton, LoadingPage, Toast, ProuniPipelineMenu },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    canContinue: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
});
